import React, { useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import NutritionAllergenCard from './NutritionAllergenCard';
import Accordian from 'atoms/Accordian/Accordian';
import { UserOrderContext } from 'context/context';
import { showCustomizationModalAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { jsontoObjects } from 'common/utilities/utils';
import { CAROUSEL_RESPONSIVE_SETTINGS } from 'common/constants/SharedConstants';

const caroselDefaults = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  adaptiveHeight: false,
  autoplay: false,
  variableWidth: true,
  responsive: CAROUSEL_RESPONSIVE_SETTINGS,
};
export const filterProducts = (productsArray, hasMultipleItems) => {
  const itemsArray = [];
  !!productsArray.length &&
    productsArray.forEach(elm => {
      let item = null;
      let itemObj = null;
      const { url, name } = elm;
      if (hasMultipleItems?.includes(url)) {
        ({ items: item } = elm);
        itemObj = { url, name, item };
        itemsArray.push(itemObj);
      } else {
        ({
          items: [item],
        } = elm);
        itemObj = { url, name, item };
        itemsArray.push(itemObj);
      }
    });
  return itemsArray;
};
const renderProducts = (productsArray, cardRenderer, hasMultipleItems) => {
  const items = filterProducts(productsArray, hasMultipleItems);
  return (
    !!items.length &&
    items.map(elm => {
      return cardRenderer(elm);
    })
  );
};

const getMenuItemData = (id, product, itemFoodlineId) => {
  return {
    foodName: product?.productName[0]?.value,
    foodItemId: id,
    cartPrice: product?.productPrice,
    modifiers: [],
    quantity: 1,
    foodLineId: itemFoodlineId,
  };
};

const getCategoryId = (categoryId, item) => {
  return categoryId !== '' ? categoryId : item.category_id;
};

const NutritionAllergenItemList = props => {
  const { productList = [], tenantData = {} } = props;
  const { hasMultipleItems = [] } = tenantData;
  const dispatch = useDispatch();
  const [selectedCat,] = useState(props.selectedCat);
  const { userOrderState,} = useContext(UserOrderContext);

  const [activeId,] = useState(null);
  const onClickHandler = event => {
    const accordian = event.target.parentElement.parentElement.parentElement;
    accordian.classList.contains('nutrition-accordian-open')
      ? accordian.classList.remove('nutrition-accordian-open')
      : accordian.classList.add('nutrition-accordian-open');
  };

  const currentItemDetails = useSelector(({ menuReducer }) => menuReducer?.currentItemDetails);
  useEffect(() => {
    if (currentItemDetails && selectedCat && userOrderState.minipdpData.itemId === currentItemDetails.id) {
      //to set flag in cartReducer
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: true,
          categorySelected: selectedCat,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentItemDetails]);

  const cardRenderer = (itemDetail = {}) => {
    const { item, url, name } = itemDetail;
    const { dname: dName, content } = item;
    const additionalProperties = jsontoObjects(item.additionalProperties);
    if (hasMultipleItems?.includes(url)) {
      return (
        <div className='nutrition-accordian'>
          <Accordian data-testId='acordian-handle' header={name} onClickHandler={onClickHandler}>
            {item.map((itemObject) => {
              return (
                <NutritionAllergenCard
                  item={itemObject}
                  key={itemObject.id}
                  activeId={activeId}
                  tenantData={tenantData}
                  data-testid='menu-card-component'
                  dName={itemObject.dname[0].value}
                  contentData={itemObject.content}
                  {...additionalProperties}
                  {...itemObject}
                />
              );
            })}
          </Accordian>
        </div>
      );
    } else {
      return (
        <NutritionAllergenCard
          item={item}
          key={item.id}
          activeId={activeId}
          tenantData={tenantData}
          data-testid='menu-card-component'
          dName={dName}
          contentData={content}
          {...additionalProperties}
          {...item}
        />
      );
    }
  };

  return (
    <>
      <div className='product-container'>{renderProducts(productList, cardRenderer, hasMultipleItems)}</div>
    </>
  );
};

export default withRouter(NutritionAllergenItemList);
